// The single Supabase client for the whole app.
//
// We read the project URL + anon key from environment variables (see
// .env.example). If they are missing, `isSupabaseConfigured` is false and the
// UI shows a friendly setup screen instead of crashing. This lets a new
// developer clone the repo and run `npm run dev` before they have credentials.

import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/** True once both env vars are present (i.e. the app is pointed at a real backend). */
export const isSupabaseConfigured = Boolean(url && anonKey);

// We always construct a client (even with placeholders) so imports never throw.
// Components gate real network calls behind `isSupabaseConfigured`.
export const supabase: SupabaseClient = createClient(
  url || "https://placeholder.supabase.co",
  anonKey || "placeholder-anon-key"
);
